import React, {Component} from 'react';
import * as R from 'ramda';

class AccountManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exportDisabled: true,
            htmlForPdf: ''
        };
    }

    handleFrameOnLoad = e => {
        const htmlForPdf = e.target.contentDocument.body.innerHTML.trim();
        this.setState({
            exportDisabled: false,
            htmlForPdf
        });
    };

    handleExportPdf = e => {
        e.preventDefault();
        const form = e.target.parentNode;
        const {htmlForPdf} = this.state;

        if (htmlForPdf.length) {
            form.submit();
        }
    };

    displayDownloadWrapUp = () => {
        const {renderForPdf, campaignWrapUpExportUrl, campaignWrapUpPdfUrl} = this.props;
        const {exportDisabled, htmlForPdf} = this.state;

        if (!renderForPdf) {
            return (
                <div className="account-manager-download-wrap-up">
                    <form method="post" action={campaignWrapUpExportUrl} target="_blank">
                        <button
                            className="cta-button"
                            disabled={exportDisabled}
                            onClick={this.handleExportPdf}
                        >
                            DOWNLOAD REPORT
                        </button>
                        <input type="hidden" name="value" value={htmlForPdf} />
                    </form>
                    <iframe
                        className="account-manager-wrap-up-frame"
                        src={campaignWrapUpPdfUrl}
                        onLoad={this.handleFrameOnLoad}
                        height="0"
                        width="0"
                    />
                </div>
            );
        }
    };

    displayCtaLinks = () => {
        const {renderForPdf, viewCampaignsUrl, analyticsUrl, campaignId} = this.props;
        const analyticsDashboardUrl = analyticsUrl.replace('__id__', campaignId);

        if (!renderForPdf) {
            return (
                <div className="account-manager-cta-links">
                    <div className="cta-link-section">
                        <a href={analyticsDashboardUrl}>
                            <button className="cta-button">UPLOAD TO FACEBOOK</button>
                        </a>
                        <div className="cta-text">
                            {
                                'Maximize the value of your content by reusing it across your paid channels. Push content direclty to Facebook from the Content Gallery.'
                            }
                        </div>
                    </div>
                    <div className="cta-link-section">
                        <a href={analyticsDashboardUrl}>
                            <button className="cta-button">RATE &amp; DOWNLOAD YOUR CONTENT</button>
                        </a>
                        <div className="cta-text">
                            {
                                'Rate all of your content in the analytics dashboard and view your images according to repurposability.'
                            }
                        </div>
                    </div>
                    <div className="cta-link-section">
                        <a href={viewCampaignsUrl}>
                            <button className="cta-button">RUN YOUR NEXT CAMPAIGN</button>
                        </a>
                        <div className="cta-text">
                            {
                                "Run a follow-up campaign that's optimized based upon your highest scoring content from the most recent campaign."
                            }
                        </div>
                    </div>
                </div>
            );
        }
    };

    render() {
        const {email, profilePictureUrl, defaultProfilePicture, renderForPdf} = this.props;

        // Remove internal SN email suffix: '+admin', '+test', etc
        const mailto = R.isNil(email) ? 'nancy@socialnative.com' : email.replace(/\+.*(?=@)/g, '');
        const ctaLinks = this.displayCtaLinks();
        const downloadWrapUp = this.displayDownloadWrapUp();

        return (
            <div className="account-manager">
                {ctaLinks}
                <div className="account-manager-body">
                    <div className="account-manager-image" />
                    <div className="account-manager-info">
                        <p className="account-manager-says-hi">
                            <span>
                                {
                                    'THANK YOU! For a more in depth analysis please visit your campaign dashboard.  If you have any questions feel free to contact me at '
                                }
                            </span>
                            <span>
                                <a id="account-manager-email" href={`mailto:${mailto}`}>
                                    {mailto}
                                </a>
                                .
                            </span>
                        </p>
                        {downloadWrapUp}
                    </div>
                </div>

                {/*STYLES*/}

                <style>{`
                    .account-manager {
                        width: 100%;
                        background-color: #00A1E1;
                        padding: 10px 0px 80px 0px;
                    }

                    .account-manager-download-wrap-up {
                        padding-top: 20px;
                    }

                    .account-manager-wrap-up-frame {
                        display: none;
                    }


                    .account-manager-cta-links {
                        margin-bottom: 40px;
                    }

                    .cta-link-section {
                        width: 357px;
                        padding: 20px 0px;
                    }

                    .cta-link-section a:hover {
                        text-decoration: none;
                    }

                    .cta-button {
                        display: block;
                        color: #00A1E1;
                        background-color: #FFF;
                        font-size: 16px;
                        font-weight: bold;
                        border: 1px;
                        border-style: solid;
                        border-radius: 50px;
                        padding: 18px 30px;
                        margin: 30px 0px
                    }

                    .cta-button:hover {
                        color: #FFF;
                        background-color: transparent;
                        text-decoration: none;
                    }

                    .cta-text {
                        font-size: 14px;
                        font-weight: 200;
                        color: #FFF;
                        text-align: center;
                        padding: 0px 50px;
                    }

                    .account-manager-image {
                        height: 200px;
                        width: 200px;
                        background-image: url(${profilePictureUrl || defaultProfilePicture});
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: cover;
                        border-radius: 50%;
                        margin: 20px 70px;
                    }

                    .account-manager-info {
                        width: 70%;
                        font-size: 28px;
                        font-weight: 200;
                        color: #FFF
                    }

                    .account-manager-says-hi {
                        word-wrap: break-word;
                        padding-right: 40px;
                    }

                    #account-manager-email {
                        font-weight: bold;
                        color: #FFF;
                    }

                    .download-report-button {
                        display: block;
                        color: #00A1E1;
                        font-size: 25px;
                        font-weight: bold;
                        background-color: #FFF;
                        border: none;
                        border-style: solid;
                        border-radius: 50px;
                        padding: 20px 50px;
                        margin: 20px 0px;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .account-manager {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }

                        .account-manager-cta-links {
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                        }

                        .cta-link-section {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            flex-wrap: wrap;
                        }

                        .account-manager-body {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-wrap: wrap;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .account-manager {
                            page-break-before: always;
                            text-align: center;
                            padding: 200px 0px 720px 0px;
                        }

                        .account-manager-cta-links {
                        }

                        .cta-link-section {
                            display: inline-block;
                            vertical-align: top;
                            width: 40%;
                            height: 150px;
                        }

                        .cta-link-section a {
                            width: 100%;
                            text-decoration: none;
                        }

                        .cta-button {
                            margin: 30px auto;
                        }

                        .account-manager-body {
                            padding-top: 20px;
                        }

                        .account-manager-image {
                            margin: 40px auto;
                        }

                        .account-manager-info {
                            margin: auto;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

AccountManager.propTypes = {};

export default AccountManager;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/account_manager/index.js